import { cardsData, mediaData, commentsData } from '@/mocks/homeData';

export function SectionCards() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          精选推荐
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          编辑精选品质漫画，每一部都值得细细品读
        </p>

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cardsData.slice(0, 7).map((item, i) => (
            <div
              key={i}
              className={`group bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 overflow-hidden transition-all flex flex-col ${
                i === 6 ? 'sm:col-span-2 lg:col-span-1 xl:col-span-1' : ''
              }`}
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`${item.title}漫画封面 - 亲亲漫画高清阅读`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2.5 py-1 text-xs font-medium bg-background-50/90 text-primary-600 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-tight">
                  《{item.title}》
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {item.desc}
                </p>
                <a
                  href="#app"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector('#app');
                    if (el) {
                      const top = el.getBoundingClientRect().top + window.scrollY - 80;
                      window.scrollTo({ top, behavior: 'smooth' });
                    }
                  }}
                  className="mt-3 inline-flex items-center gap-1.5 text-xs font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  下载APP阅读
                  <i className="ri-arrow-right-s-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function SectionMedia() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          视频专区
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          漫评解说、新番推荐、深度访谈，视频内容持续更新
        </p>

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaData.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-200 overflow-hidden transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-300">
                <img
                  src={item.image}
                  alt={`${item.title}视频封面 - 亲亲漫画视频专区`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/90">
                    <i className="ri-play-fill text-background-50 text-sm"></i>
                  </div>
                  <span className="text-xs font-medium text-background-50 bg-black/50 px-2 py-0.5 rounded whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function SectionComments() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          读者评价
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          来自真实用户的使用反馈，口碑是最好的证明
        </p>

        <div className="mt-8 md:mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {commentsData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={item.avatar}
                    alt={`${item.name}头像`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {item.name}
                  </h3>
                  <p className="text-xs text-foreground-500">{item.date}</p>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: item.rating }).map((_, j) => (
                    <i key={j} className="ri-star-fill text-accent-500 text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed flex-1">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}